.errorMessage {
  color: red;
  margin: 4px;
}

.filesEdit {
  display: flex;
  flex-flow: row wrap;
  width: 380px;
  margin-left: 10px;
}
.filesEdit .file {
  flex: 1 auto;
  width: 180px;
  height: 180px;
  position: relative;
  margin: 5px;
  margin-bottom: 32px;
  border-radius: 5px;
  box-shadow: 2px 2px 5px #444;
}
.filesEdit .file .controls {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.filesEdit .file .filePlaceholder {
  display: block;
  font-size: 40px;
  text-align: center;
  line-height: 180px;
  border-radius: 5px;
  color: #aaa;
  text-shadow: -1px -1px 1px #555, 1px 1px 1px #ddd;
  box-shadow: 2px 2px 1px #888;
}
.filesEdit .file .fileName {
  position: absolute;
  top: 100px;
  font-size: 11px;
  font-weight: bold;
  color: #222;
  width: 100%;
  text-shadow: 0 0 3px #aaa;
}

.fileProgress {
  color: black;
  font-size: 12px;
}
.fileProgress .reprogress {
  display: none;
}

.dropzone {
  border: 5px dashed gray;
  border-radius: 16px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.dropzone.changing {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-color: #d54;
  border-radius: 5px;
}
.dropzone.changing .icon {
  margin-top: -12px;
  color: #d54;
  text-shadow: 1px 1px 1px #222;
  opacity: 0.6;
}
.dropzone .icon {
  display: block;
  font-size: 64px;
  color: gray;
  line-height: 200px;
  text-align: center;
  width: 100%;
}
.dropzone.active {
  border-style: solid;
}
.dropzone.accept {
  border-color: green;
}

.pleaseDontDeleteMe {
  margin: auto;
  margin-top: 10px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */